import { useSelector } from "react-redux";
import { hasPermissionCode } from "../utils/permission";

export function useHasPermission(code: string): boolean {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const permissions = useSelector((s: any) => (s.general?.permissions ?? []) as any[]);
  return hasPermissionCode(permissions, code);
}
